export const pt = {
    common: {
        aloapp: "A aloPay é uma forma cómoda, rápida e económica de efetuar pagamentos, tratar de clientes e gerar facturas",
        offer: "A plataforma oferece :",
        easyPayment: "Processamento fácil de",
        processing:"Pagamentos",
        invoiceGe: "Geração de facturas",
        receiptsGe: "Geração de recibos",
        our: "O nosso",
        solution: "Solução",
        processPay: "Processe pagamentos sem problemas para todas as facturas. Integre-se com gateways de pagamento seguros para recolher pagamentos diretamente dos clientes",
        home: "Configurar a integração de pagamentos e a fatura",
        control: "Do cliente ao fluxo de caixa: uma plataforma, controle total.",
        explore: "Explorar Plataforma",
        why: "Por que Escolher",
        handle: "Gerencie seus pagamentos, contas e clientes em um só lugar.",
        digital: "Torne-se digital, crie, envie e rastreie pagamentos facilmente em tempo real, reduzindo erros manuais e acelerando ciclos de pagamento.",
        easy: "Processamento de Pagamento Simplificado",
        process: "Processe pagamentos de todas as faturas sem complicações.",
        integrate: "Integre com gateways de pagamento seguros para receber pagamentos diretamente dos clientes.",
        secure: "Seguro",
        local: "Moeda local",
        payout_number: "Número do pagamento(0551611100)",
        enter_account: "Introduzir o nome da conta",
        momo:"Número Momo",
        momo_name:"Momo name",
        provider:"Nome do fornecedor",
        select_provider:"Selecionar fornecedor",
        instant: "transferência instantânea",
        real: "Análises em Tempo Real",
        provide: "Fornece uma visão financeira geral e análises detalhadas de suas faturas totais, valor ganho e histórico.",
        analytics: "análises",
        insights: "insights",
        time: "tempo real",
        safe: "Seguro e Protegido",
        keep: "Mantenha suas faturas e informações de clientes seguras com nossa plataforma confiável. Acesse seus dados a qualquer hora, em qualquer lugar.",
        cloud: "baseado em nuvem",
        encrypt: "criptografado",
        login: "Login / Cadastro",
        welcome: "Bem-vindo!",
        log: "Faça login ou crie uma conta para começar.",
        success: "sucesso!",
        successful: "Login Realizado com Sucesso!",
        sign: "Entre com suas credenciais",
        forgot: "Esqueceu a senha?",
        create: "Criar nova conta",
        signin: "Entrar",
        register: "Registro Realizado com Sucesso!",
        registration: "Falha no registro—tente novamente!",
        error: "Erro",
        name: "Nome",
        email: "Email",
        company: "Nome da Empresa",
        phone: "Telefone",
        password: "Senha",
        upload: "Carregar Logo",
        account: "criar conta",
        loggin: "Entrar",
        wrong: "Email ou senha incorretos!",
        language: "Idioma",
        reset: "Redefinir Senha!",
        request: "Solicitar Redefinição de Senha",
        match: "As senhas não correspondem.",
        reset_success: "Senha redefinida com sucesso.",
        reset_fail: "Falha ao redefinir senha.",
        enter: "Digite sua nova senha",
        password_sent: "Link de redefinição de senha enviado para seu email.",
        password_failed: "Falha ao enviar link de redefinição de senha.",
        enter_mail: "Digite seu email",
        request_reset: "Solicitar Redefinição",
        terms: "Termos e Condições",
        privacy: "Política de Privacidade",
         commission: "Comissão",
        alovroom: "Receitas da Alovroom"
    },

    sidenav: {
        dash: "Painel",
        profile: "Perfil",
        add_user: "Adicionar Usuário",
        category: "Categorias",
        add_category: "Adicionar Categoria",
        product: "Produtos",
        add_product: "Adicionar Produto",
        customer: "Clientes",
        add_customer: "Adicionar Cliente",
        invoice: "Faturas",
        add_invoice: "Adicionar Fatura",
        accounts: "Contas",
        wallet: "Carteira"
    },

    dashboard: {
        invoice: "Fatura Concluída",
        details: "ver detalhes",
        users: "Usuários",
        customers: "Clientes",
        products: "Produtos",
        dash: "Painel",
        profile: "Meu perfil",
        logout: "Sair"
    },

    profile: {
        management: "Gestão de Perfil",
        adduser: "Adicionar Usuário",
        profile: "Perfil",
        phone: "Telefone",
        name: "Nome",
        edituser: "Editar usuário",
        deleteuser: "Excluir usuário",
        success: "sucesso!",
        userupdated: "Usuário Atualizado",
        failed: "Falha na atualização do usuário",
        submit: "Enviar",
        cancel: "Cancelar",
        sure: "Tem certeza?",
        error: "Erro",
        successful: "Criação de usuário bem-sucedida!",
        not_successful: "Falha na criação do usuário—tente novamente!",
        delete_text: "Você não poderá reverter isso!",
        delete_confirm: "Sim, excluir!",
        delete_success_title: "Excluído!",
        delete_success_message: "Seu usuário foi excluído.",
        delete_error_title: "Ocorreu um erro inesperado. Por favor, tente novamente."
    },

    category: {
        delete_text: "Você não poderá reverter isso!",
        delete_confirm: "Sim, excluir!",
        sure: "Tem certeza?",
        not_successful: "Falha ao excluir categoria. Por favor, tente novamente.",
        delete_error_title: "Ocorreu um erro inesperado. Por favor, tente novamente.",
        management: "Gestão de Categorias",
        add_category: "Adicionar Categoria",
        cat: "Categoria",
        delete_category: "Eliminar categoria",
        edit_category: "Editar categoria",
        updated: "Categoria Atualizada",
        failed: "Falha na atualização da categoria",
        search: "Pesquisar categorias",
        edit_category_details: "Editar detalhes da categoria",
        successful: "Criação de categorias bem-sucedida!",
        not_successfull: "Falha na criação de categorias—tente novamente!",
        remove: "Remover",
        add_another: "Adicionar Outra Categoria",
        category_name: "Nome da categoria"
    },

    product: {
        not_successful: "Falha ao excluir produto. Por favor, tente novamente.",
        deleted: "Seu produto foi excluído.",
        management: "Gestão de Produtos",
        products: "Produtos",
        add_products: "Adicionar produtos",
        search: "Pesquisar produtos...",
        product_name: "Nome do produto",
        quantity: "Quantidade",
        price: "Preço",
        delete: "Excluir Produto",
        edit: "Editar Produto",
        edit_details: "Editar Detalhes do Produto",
        product_updated: "Produto Atualizado",
        failed: "Falha na atualização do produto",
        details: "Detalhes",
        seterror: "A categoria é obrigatória para cada produto e a quantidade deve ser não-negativa.",
        select: "Selecione uma categoria",
        add_another: "Adicionar Outro Produto",
        successful: "Criação do produto bem-sucedida!",
        not_successfull: "Falha na criação do produto—tente novamente!"
    },

    customer: {
        not_successful: "Falha ao excluir cliente. Por favor, tente novamente.",
        deleted: "Seu cliente foi excluído.",
        customers: "Clientes",
        management: "Gestão de Clientes",
        add_customer: "Adicionar Cliente",
        address: "Endereço",
        country: "País",
        edit_customer: "Editar Cliente",
        edit_customer_details: "Editar Detalhes do Cliente",
        updated: "Cliente Atualizado",
        successful: "Criação do cliente bem-sucedida!",
        not_successful: "Falha na criação do cliente—tente novamente!",
        town: "Cidade",
        add_another: "Adicionar Outro Cliente",
        select: "Selecione um país",
        search: "Pesquisar clientes..."
    },

    invoice: {
        invoices: "Faturas",
        payment_confrim: "Confirmação de Pagamento",
        proceed: "Prossiga clicando em pagar agora",
        pay_now: "Pagar agora com PawaPay",
        pay_now_stack: "Pagar agora com Paystack",
        proccessed: "O pagamento será processado em GHS",
        equivalent: "Equivalente",
        management: "Gestão de Faturas",
        add_invoice: "Adicionar Fatura",
        payment_success: "Status do pagamento atualizado com sucesso",
        not_updated: "Status do pagamento não atualizado",
        search: "Pesquisar faturas...",
        Utilisateurs: "Pesquisar Usuários...",
        filter: "Filtro",
        customer_name: "Nome do Cliente",
        customer_country: "País do Cliente",
        customer_address: "Endereço do Cliente",
        customer_email: "Email do Cliente",
        customer_phone: "Telefone do Cliente",
        invoice_date: "Data da Fatura",
        customer_product_name: "Nome do Produto",
        quantity: "Quantidade",
        price: "Preço",
        discount: "Desconto",
        subtotal: "Subtotal",
        status: "Status",
        paid: "Pago",
        clear:"claro",
        not_paid: "Não Pago",
        edit_invoice: "Editar fatura",
        edit_invoice_details: "Editar detalhes da fatura",
        delete_invoice: "Excluir fatura",
        payment_link: "Enviar link de pagamento",
        send_receipt: "Enviar recibo",
        print_invoice: "Imprimir fatura",
        updated: "Fatura Atualizada",
        not_updatedd: "Fatura não atualizada",
        link_sent: "Link de pagamento enviado",
        link_not__sent: "email incorreto ou link já enviado",
        to: "Para",
        submitting: "Enviando...",
        receipt_sent: "Recibo enviado",
        receipt_not_sent: "email incorreto ou email já enviado",
        not_successfull: "Falha ao excluir fatura. Por favor, tente novamente.",
        deleted: "Sua fatura foi excluída.",
        select_customer: "Selecione um cliente",
        select_product: "Selecione um produto",
        successfull: "Criação da fatura bem-sucedida!",
        not_successful: "Falha na criação da fatura—tente novamente!",
        loading: "Carregando fatura...",
        error_invoice: "Erro ao Carregar Fatura",
        retry: "Tentar novamente",
        not_found: "Fatura Não Encontrada",
        not_be_found: "A fatura solicitada não pôde ser encontrada.",
        choosing: "Obrigado por nos escolher,",
        location: "Localização:",
        amount: "Valor",
        initiate: "Iniciar Pagamento"
    },

    wallet: {
        balance: "Saldo da Carteira",
        setup: "Configurar Carteira",
        banks: "Selecionar Banco",
        select_bank: "Selecione um banco",
        account_number: "Número da Conta",
        veirfy: "Verificar",
        account_name: "Nome da Conta",
        setup_wallet: "Configurar Carteira",
        withdrawal: "Solicitação de Saque",
        amount: "Valor",
        request: "Solicitar Saque",
        withdrawal_request: "Solicitações de Saque",
        bank: "Banco",
        status: "Status",
        no_withdrawall: "Nenhuma solicitação de saque encontrada",
        valid: "Por favor, insira um número de conta válido e selecione um banco",
        wrong: "Conta ou banco incorretos",
        verified: "Verificado",
        verify_account: "Por favor, verifique seu número de conta primeiro",
        wallet_setup: "Configuração da carteira bem-sucedida!",
        insufficient: "Saldo insuficiente",
        wallet: "Carteira"
    }
};